import React from 'react';
import Carousel from 'nuka-carousel';
import { connect } from 'react-redux';
import background from './background.module.css';
import {SliderDiv} from './FilterBanner';

import img8 from '../../../images/icons/arrowLeft.png';
import img9 from '../../../images/icons/arrowRight.png';

class FilterSlider extends React.Component{
  render() {
    const styles = {
      buttonStyle : {
        paddingLeft: "0.8rem",
        paddingRight: "0.8rem",
        paddingTop: "1.1rem",
        paddingBottom: "0.8rem",
        borderStyle:"none",
        background:"#fff",
        borderRadius: "14px",
      },
      buttonStyle2 : {
        paddingLeft: "0.8rem",
        paddingRight: "0.8rem",
        paddingTop: "0.9rem",
        paddingBottom: "0.8rem",
        borderStyle:"none",
        background:"#fff",
        borderRadius: "14px",
      },
    };
    const { selectedListing, } = this.props.filterSearch;
    return (
      <SliderDiv >
        <Carousel autoplay={false} wrapAround={true}
          renderCenterLeftControls={({ previousSlide }) => (
            <button style={styles.buttonStyle} onClick={previousSlide}>
              <img 
                src={img8} 
              title='LFC' alt='LFC'/>
            </button>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <button style={styles.buttonStyle2} onClick={nextSlide}><img src={img9} title='LFC' alt='LFC' /></button>
          )}
        >
          <img className={`${background.background} sliderImgblog`} 
            alt='LFC' title='Life Care Front' 
            src={!!selectedListing && typeof(selectedListing.description) === 'string' ? 
                 selectedListing.imgUrl1 : ''} />

          <img className={`${background.background} sliderImgblog`} 
            alt='LFC' title='Life Care Front' 
            src={!!selectedListing && typeof(selectedListing.description) === 'string' ? 
                 selectedListing.imgUrl2 : ''} />

          <img className={`${background.background} sliderImgblog`} 
            alt='LFC' title='Life Care Front' 
            src={!!selectedListing && typeof(selectedListing.description) === 'string' ? 
                 selectedListing.imgUrl3 : ''} />
          
          <img className={`${background.background} sliderImgblog`} 
            alt='LFC' title='Life Care Front'
            src={!!selectedListing && typeof(selectedListing.description) === 'string' ? 
                 selectedListing.imgUrl4 : ''} />
          
          <img className={`${background.background} sliderImgblog`} 
            alt='LFC' title='Life Care Front' 
            src={!!selectedListing && typeof(selectedListing.description) === 'string' ?
                 selectedListing.imgUrl5 : ''} />
          
          <img className={`${background.background} sliderImgblog`} 
            alt='LFC' title='Life Care Front' 
            src={!!selectedListing && typeof(selectedListing.description) === 'string' ? 
                 selectedListing.imgUrl6 : ''} />
          
          <img className={`${background.background} sliderImgblog`} 
            alt='LFC' title='Life Care Front' 
            src={!!selectedListing && typeof(selectedListing.description) === 'string' ? 
                 selectedListing.imgUrl7 : ''} />
          
          <img className={`${background.background} sliderImgblog`} 
            alt='LFC' title='Life Care Front' 
            src={!!selectedListing && typeof(selectedListing.description) === 'string' ? 
                 selectedListing.imgUrl8 : ''} />
          
          <img className={`${background.background} sliderImgblog`} 
            alt='LFC' title='Life Care Front' 
            src={!!selectedListing && typeof(selectedListing.description) === 'string' ? 
                 selectedListing.imgUrl9 : ''} />
          <video 
            width="300" height="400" controls poster={`${!!selectedListing && 
                typeof(selectedListing.description) === 'string' ?
                selectedListing.imgUrl1 : ''}`}>
            <source src={selectedListing.videourl} type="video/mp4"></source>
            <source src="" type="video/ogg"></source>       
          </video>
        </Carousel>
      </SliderDiv>
    );
  };
};

const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(FilterSlider);